import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import auth from "./reducers/Auth";
import messages from "./reducers/Messages";
import permissions from "./reducers/Permissions";
import roles from "./reducers/Roles";
import users from "./reducers/Users";

export default combineReducers({
  auth,
  messages,
  router: routerReducer,

  /**
   * Add your reducers here
   */
  permissions,
  roles,
  users
});



// WEBPACK FOOTER //
// ./src/redux/rootReducer.js